import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

const modelUrl = process.env.REACT_APP_MODELPATH+"sofacushion3.glb";

export default function SofaCushion3Model(props) {
  const group = useRef();
  const { nodes, materials } = useGLTF(modelUrl);
  return (
    <group ref={group} {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Object537.geometry}
        material={materials["Custom (2)"]}
      />
    </group>
  );
}

useGLTF.preload(modelUrl);